<template>
  <v-row>
    <UserInfoSideBar />
    <v-container justify-start>
      <v-row>
        <span class="font-weight-black text-h6 mt-7 ml-10">下書き一覧</span>
      </v-row>
      <template v-if="loading">
        <v-row justify="center" align-content="center" class="mt-10">
          <img src="../../assets/loading.gif">
        </v-row>
      </template>
      <template>
        <v-row class="mt-5 mx-12" v-if="isExistDraft">
          <v-col
            v-for="(item, i) in topics"
            :key="i"
          >
            <v-card
              class="mx-auto mt-0 d-flex flex-column"
              width="306"
              height="369"
              outlined
            >
              <router-link :to="{ name: 'topic_draft', params: { topic_code: item.topic_code }}" style="text-decoration: none;">
                <v-img
                  class="white--text align-end"
                  style="height:170px"
                  :src="`${bucketUrl}${item.topic_image_url}`"
                >
                </v-img>
              </router-link>
              <v-card-text class="pt-4 overflow-auto">
                <router-link :to="{ name: 'topic_draft', params: { topic_code: item.topic_code }}" 
                  class="font-weight-bold pt-0 mb-2"
                  style="
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    text-decoration: none;
                    color: black;
                  "
                >{{ item.topic_name }}</router-link>
                <span v-for="tag in item.tags" :key="tag.tag_name" class="mr-2">
                  <v-btn
                    depressed
                    dark
                    color="#333333"
                    @click="searchTag(tag.tag_name)"
                    x-small
                    class="font-weight-bold"
                    style="text-transform: none"
                  >{{ tag.tag_name }}</v-btn>
                </span>
              </v-card-text>
              <v-spacer></v-spacer>
              <v-divider class=""></v-divider>
              <v-card-text>
                <v-row class="pa-0">
                  <v-col cols="6" class="justify-start" style="color: black; font-size: 10px;">
                    <span>作成日：{{ formatDate(item.created_at) }}</span>
                  </v-col>
                  <v-col cols="3" class="" style="color: black; font-size: 14px;">
                    <v-icon size="16">mdi-heart</v-icon><span class="ml-1">{{ item.lgtm }}</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else>
          <p class="ml-10 mt-5">下書きはありません</p>
        </v-row>
      </template>
    </v-container>
  </v-row>
</template>
<script>
import dayjs from 'dayjs';
import UserInfoSideBar from '../organisms/UserInfoSideBar';

export default {
  name: 'TopicList',
  components :{
    UserInfoSideBar,
  },
  data() {
    return {
      loading: true,
      drawer: true,
      user: {},
      total_count: null,
      topics: {},
      user_code:'',
      bucketUrl: process.env.VUE_APP_IMAGE_BUCKET_URL,
      isExistDraft: true,
    }
  },
  async mounted() {
    await this.getDraft()
  },
  computed: {
    icon: function() {
      return this.user.icon_url
    },
  },
  methods: {
    getDraft() {
      this.user_code = this.$store.getters['auth/isUserCode']
      this.$store.dispatch('topicList/getDraft')
        .then(() => {
          this.topics = this.$store.getters['topicList/draftTopic']
          this.total_count = this.topics.length;
          if (this.total_count === 0) {
            this.isExistDraft = false;
          }
          this.loading = false;
        })
      this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/user/' + this.user_code)
        .then(response => {
          this.user = response.data
        });
    },
    formatDate: dateStr => dayjs(dateStr).format('YYYY/MM/DD'),
    linkToProfile() {
      this.$router.push({name: 'user', params: {user_code: this.user_code}})
    }
  },
}
</script>

<style src="./TopicList/TopicList.scss" lang="scss"></style>